import { createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteVouchersSubvouchersParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";

import axios from "axios";

export const deleteVouchersSubvouchers = createAsyncThunk<
  void,
  DeleteVouchersSubvouchersParams
>(
  "vouchers/deleteVouchersSubvouchers",
  async ({ subVoucherId, ...params }, { rejectWithValue }) => {
    try {
      await VouchersAPI.deleteVouchersSubvouchers({
        subVoucherId,
        ...params,
      });
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while deleting subvouchers",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error("Error while deleting subvouchers", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
